/*eslint-env jquery*/

import angular from 'angular';
import uiRouter from 'angular-ui-router';

export default angular.module('directives.busDetail', [uiRouter])
  .component('busDetail', {
    template: require('./bus-detail.template.html'),
    controller: ['$http', '$stateParams',
      function BusDetailComponent($http, $stateParams) {
        var that = this;

        $http.get(`data/${$stateParams.busId}.json`).then(function(response) {
          that.bus = response.data;
        });
      }
    ]

  })
  .directive('slickSlider', ['$timeout',
    function($timeout) {
      return {
        restrict: 'A',
        link(scope, element) {
          $timeout(function() {
            $(element).slick({
              arrow: true,
              dots: true,
              infinte: true,
              draggable: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '30%',
              adaptiveHeight: true
            });
          });
        }
      };
    }
  ])
  .name;



// WEBPACK FOOTER //
// ./client/app/main/bus-detail/bus-detail.component.js